import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  EXCEPTION_CATEGORY_ENUM,
  IExceptionMetadata,
  OauthAEMConfig
} from '@com-delta-idp/mnx-oauth';
import {
  ApiBuilder,
  AppConfigService,
  EXCEPTION_FILE_NAMES_ENUM,
  ExceptionTrackingService,
  HttpRequestMethods
} from '@com-delta-idp/mnx-utils';
import { Observable, throwError } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { IDP_APP } from '../constants/login-constant';
import { LoginModalEndpointsKeys } from '../models/login-modal.enum';

@Injectable({
  providedIn: 'root'
})
export class PingOauthService {
  authConfigJson!: Observable<OauthAEMConfig>;
  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private exceptionTrackingService: ExceptionTrackingService
  ) {}

  getAuthConfigContent(): Observable<OauthAEMConfig> {
    if (this.authConfigJson) {
      return this.authConfigJson;
    } else {
      this.authConfigJson = this.getConfigforPingAPI().pipe(shareReplay(1));
      return this.authConfigJson;
    }
  }

  getConfigforPingAPI = (): Observable<OauthAEMConfig> =>
    new ApiBuilder<undefined, OauthAEMConfig>(this.http, this.appConfig)
      .app('COMMON')
      .endpointKey(LoginModalEndpointsKeys['APP_AUTH_CONFIG_JSON'])
      .method(HttpRequestMethods['GET'])
      .errorHandler(this.handleError.bind(this))
      .create();

  handleError(error: HttpErrorResponse): Observable<never> {
    const exceptionMetadata: IExceptionMetadata = {
      fileName: EXCEPTION_FILE_NAMES_ENUM.LOGIN_PING_OAUTH_SERVICE,
      methodName: '_handleError',
      exceptionCategory: EXCEPTION_CATEGORY_ENUM.API_FAILURE,
      exceptionMessage: error.error
    };
    this.exceptionTrackingService.track(
      `[${IDP_APP}]: ${error.status} : ${error.url}`,
      exceptionMetadata
    );
    return throwError(error);
  }
}
